import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';

interface ShiftCustomFactSemiState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    prefereds: any;
    relatedFactsList: any[];
    meta: any;

    targetForDelete: any[];
    remains: any[];
}

const state: ShiftCustomFactSemiState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,
    meta: {},

    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    remains: []
};

const initState: any = cloneDeep(state);

const GET_SHIFT_SEMI_FACT = 'GET_SHIFT_SEMI_FACT';
const GET_SCMEMA_SHIFT_CUSTOM_FACT = 'GET_SCMEMA_SHIFT_CUSTOM_FACT';
const GET_SCMEMA_SHIFT_CUSTOM_PLAN = 'GET_SCMEMA_SHIFT_CUSTOM_PLAN';

export const actions: ActionTree<ShiftCustomFactSemiState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          console.debug('[ShiftCustomFactSemi] load semi facts for shift', documentId);
          vm.$db([
            vm.$q(GET_SHIFT_SEMI_FACT)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'scf.id',
                  plan_id: 'scp.id',
                  number: 'scp.number',
                  product_name: 'p.name',
                  container_name: 'pc.name',
                  quantity: 'scf.quantity',
                  is_done: 'scf.is_done',
                },
                from: 's:shift_custom_plan',
                from_as: 'scp',
                joins: [
                  {
                    join: 's:shift_custom_fact',
                    type: 'left',
                    as:   'scf',
                    on: {
                      $eq: ['scf.plan_id', 'scp.id']
                    }
                  },
                  {
                    join: 's:products',
                    type: 'left',
                    as:   'p',
                    on: {
                      $eq: ['scp.product_id', 'p.id']
                    }
                  },
                  {
                    join: 's:product_containers',
                    type: 'left',
                    as:   'pc',
                    on: {
                      $eq: ['scf.product_container_id', 'pc.id']
                    }
                  },
                ],
                order: [
                  {$asc: ['scp.number']}
                ],
                page_size: 100,
                where: {
                  $and: [
                    {$eq: [`scp.shift_id`, {$: documentId}]},
                    {$eq: [`scp.kind`, {$: 'semi'}]},
                  ]
                },
              }),
              vm.$q(GET_SCMEMA_SHIFT_CUSTOM_FACT)
              .raw('schemas.get')
              .action({
                  id: `s:shift_custom_fact`
              }),
              vm.$q(GET_SCMEMA_SHIFT_CUSTOM_PLAN)
              .raw('schemas.get')
              .action({
                  id: `s:shift_custom_plan`
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_SHIFT_SEMI_FACT);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {
                return item
              })
              console.debug('[ShiftCustomFactSemi] loaded semi facts', state.relatedFactsList.length);
            }
            const opRelSchemaFact = result.getOperation(GET_SCMEMA_SHIFT_CUSTOM_FACT);
            const opRelSchemaPlan = result.getOperation(GET_SCMEMA_SHIFT_CUSTOM_PLAN);
            if (!opRelSchemaFact.hasError()) {
              state.meta = fetchEnumsFromSchema({...opRelSchemaFact.getContent().schema, ...opRelSchemaPlan.getContent().schema} )
            }
            commit('LOADED_SUCCESS');

            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT_SEMI')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>Номер партии</td>
  <td wrap border bold bgcolor=FF72BF44 width=30>Наименование продукта</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Емкость тары</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Количество, шт</td>
</tr>
{{#facts.documents}}
  <tr height="auto">
    <td wrap border base >{{number}}</td>
    <td wrap border base >{{product_name}}</td>
    <td wrap border base align=center>{{container_name}}</td>
    <td wrap border base type=number round align=center>{{quantity}}</td>
  </tr>
{{/facts.documents}}
</table>
                `,
                queries: {
                  facts: {
                    columns: {
                      id: 'scf.id',
                      plan_id: 'scp.id',
                      number: 'scp.number',
                      product_name: 'p.name',
                      container_name: 'pc.name',
                      quantity: 'scf.quantity',
                    },
                    from: 's:shift_custom_plan',
                    from_as: 'scp',
                    joins: [
                      {
                        join: 's:shift_custom_fact',
                        type: 'left',
                        as:   'scf',
                        on: {
                          $eq: ['scf.plan_id', 'scp.id']
                        }
                      },
                      {
                        join: 's:products',
                        type: 'left',
                        as:   'p',
                        on: {
                          $eq: ['scp.product_id', 'p.id']
                        }
                      },
                      {
                        join: 's:product_containers',
                        type: 'left',
                        as:   'pc',
                        on: {
                          $eq: ['scf.product_container_id', 'pc.id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['scp.number']}
                    ],
                    where: {
                      $and: [
                        {$eq: [`scp.shift_id`, {$: documentId}]},
                        {$eq: [`scp.kind`, {$: 'semi'}]},
                      ]
                    },
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT_SEMI').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'semi-facts.xlsx')

              resolve();
          }));
      })
    },

    setDone({state, rootState, commit}, {row_id}) {
        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            const vm = (this as any)._vm;

            console.debug('[ShiftCustomFactSemi] credit semi product to warehouse, fact row', row_id);
            const saveQuery = vm.$q('SAVE')
                .update(row_id, {is_done: true})
            vm.$db([
                saveQuery
            ]).then(((result: ServerResult) => {
                console.log(result)
                commit('LOADED_SUCCESS');
                resolve();
            }));
        })
    },

};

export const mutations: MutationTree<ShiftCustomFactSemiState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },
};

export const getters: GetterTree<ShiftCustomFactSemiState, RootState> = {
    rotateFacts: (state: ShiftCustomFactSemiState) => {

      return state.relatedFactsList.reduce((prev: any, item: any) => {
        Object.keys(item).map((key: any) => {
          if (!prev[key]){
            prev[key] = [];
          }
          prev[key].push(item[key]);
        });
        prev.rows.push(item)
        return prev
      }, {rows: []})
    }
};

export const STORE_KEY = '$_shift_custom_fact_semi';

export const store = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
